import { gql, useApolloClient } from '@apollo/client';
import React, { useState } from 'react';
import Imgix from 'react-imgix';
import { animateScroll as scroll } from 'react-scroll';
import styled from 'styled-components';
import { getImgixUrl, getName, getPrice } from '../../../../../../utils/helper';
import {
  formatSegmentDataForProductAddedEvent,
  segmentTrackEvent
} from '../../../../../../utils/segmentTracking';

const CompleteTheLookItem = styled.div`
  padding: 25px;
  height: 100%;
  width: 230px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .name-fabric-price {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fabric-name {
    font-weight: 100;
    font-size: 14px;
    text-align: center;
    color: #737373;
    margin-bottom: 0px;
  }

  .name {
    line-height: 2em;
    font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  }

  .name,
  .price,
  .your-selection-text {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 16px;
    text-align: center;
    color: ${({ theme }) => theme.colors.charcoal};
    letter-spacing: 0.04em;
    opacity: 1;
  }

  .price {
    color: #6c6c6c;
  }

  .info-container {
    margin-bottom: 15px;
  }

  p,
  .your-selection-text {
    font-weight: bold;
    text-align: center;
    margin-bottom: 5px;
  }
  img {
    cursor: pointer;
    width: 100%;
    height: auto;
  }
  button {
    width: 100%;
    height: 50px;
  }

  .image-container-parent {
    padding-bottom: 100%;
    position: relative;
    background: #f7f9fa;
    width: 100%;

    .image-container {
      background: #f7f9fa !important;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      margin-top: auto;
      margin-bottom: 20px;
      align-items: center;
      justify-content: center;
      img {
      }
    }
  }

  @media (max-width: 992px) {
    width: 100%;
    .image-container {
      width: 100%;
      height: auto;
      display: flex;
      margin-top: auto;
      margin-bottom: 40px;
      align-items: center;
      justify-content: center;
    }
  }
`;

const CartButton = styled.button`
  background: ${({ theme }) => theme.old ? 'white' : theme.colors.olive};
  border-radius: ${({ theme }) => theme.buttons.primary.borderRadius};
  border: ${({ theme }) => theme.buttons.primary.border };
  color: ${props => props.theme.old && props.active ? '#2A5CAF' : props.theme.old && !props.active ? 'black' : 'white' };
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 23px;
  max-width: 150px;
  min-width: 150px;
  opacity: ${({ disabled }) => (disabled ? '0.8' : '1')};
  padding: 10px 0;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.old ? '#2a5caf' : 'white'};
    border: 1px solid ${({ theme }) => theme.old ? '#2a5caf' : theme.colors.olive};
    opacity: ${({ theme }) => theme.old ? 1 : 0.8};
  }

  &:focus {
    outline: 0;
  }
`;

const emailForNewsLetter = localStorage.getItem('emailForNewsLetter');

function Item(props) {
  const missingImage = 'https://theinside.imgix.net/common/missing-image.jpg';
  const client = useApolloClient();
  const [add, setAdd] = useState('Add to Cart');

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <CompleteTheLookItem key={props.sku}>
      <div
        className="image-container-parent"
        onClick={() => {
          if (props.setChangeFeaturedFabrics) {
            props.setChangeFeaturedFabrics(true);
          }
          props.history.push(`/products/${props.slug}`);
          scrollToTop();
        }}
      >
        <div className="image-container">
          <Imgix
            imgixParams={{ auto: 'compress,format' }}
            sizes="(min-width: 993px) 200px,
                  120px"
            src={
              props.images.length
                ? getImgixUrl(props.images[0]?.path)
                : missingImage
            }
            htmlAttributes={{
              alt: props.name,
              loading: 'lazy'
            }}
          />
        </div>
      </div>
      <div className="name-fabric-price">
        <div className="info-container">
          <p className="name">{getName(props.name)}</p>
          <p className="price">${getPrice(props.price)}</p>
          {props.size ? <p className="size">{props.size}</p> : ''}
        </div>
        {/* {props.fabric && (
          <p className="fabric-name">
            {props.fabric.name}
            {props.fabric.collaborator &&
              ' by ' + props.fabric.collaborator.name}
          </p>
        )} */}
        <CartButton
          disabled={add === 'Added'}
          onClick={() => {
            if (props.cart) {
              scrollToTop();
            }
            if (!props.isAuthenticated) {
              props.onAddProductLocalCart(props.product, 1, 1);
              segmentTrackEvent(
                'Product Added',
                formatSegmentDataForProductAddedEvent(props.product, 1)
              );
              if (emailForNewsLetter) {
                client.mutate({
                  mutation: NOTIFY_KLAVIYO,
                  variables: {
                    email: emailForNewsLetter,
                    event: 'ProductAddedToCart',
                    product_id: props.id
                  }
                });
              }
            } else {
              props.addToCart({
                variables: {
                  quantity: 1,
                  product_id: props.id,
                  type: 'increase',
                  source: props.source
                }
              });
            }
            setAdd('Added');
          }}
        >
          {add}
        </CartButton>
      </div>
    </CompleteTheLookItem>
  );
}

export default Item;

const NOTIFY_KLAVIYO = gql`
  mutation notifyKlaviyo($email: String!, $event: String!, $product_id: ID) {
    notifyKlaviyo(email: $email, event: $event, product_id: $product_id) {
      success
    }
  }
`;
